import { render, staticRenderFns } from "./SubjectText.vue?vue&type=template&id=67ce8a63&scoped=true"
import script from "./SubjectText.vue?vue&type=script&lang=js"
export * from "./SubjectText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce8a63",
  null
  
)

export default component.exports